import {
  getNombrePrestador,
  getNombreProcedimiento,
} from "./HospitalizationUtils";

export const HOSPITALIZACION_ERRORS = {
  documento: {
    CEDULA: "Cédula inválida",
    PASAPORTE: "Pasaporte inválido",
  },
};

export const HOSPITALIZACION_CONSTANT_VALUES = {
  tipoDocumento: {
    CEDULA: "CEDULA",
    PASAPORTE: "PASAPORTE",
  },
};

export const MODALIDADES_PSS = {
  ARS: "ARS",
  HIBRIDO: "HIBRIDO",
  PAQUETE: "PAQUETE",
};

export const columnasProcedimientosDetalle = (modalidadPss) => {
  const titleColumnaPrestador =
    modalidadPss === MODALIDADES_PSS.HIBRIDO ||
    modalidadPss === MODALIDADES_PSS.PAQUETE
      ? "Código y/o nombre del médico"
      : "Código y nombre del médico";

  return [
    {
      key: "codigoCobertura",
      title: "Código y nombre del procedimiento",
      dataIndex: "codigoCobertura",
      width: "43%",
      render: (_, record) => getNombreProcedimiento(record),
    },
    {
      key: "codigoPrestador",
      title: titleColumnaPrestador,
      dataIndex: "codigoPrestador",
      width: "35%",
      render: (_, record) => getNombrePrestador(record),
    },
    {
      title: "Estado",
      dataIndex: "status",
      key: "status",
      width: "12%",
    },
  ];
};
